import styled from "@emotion/styled";
import { RemoteApiEventDetail } from "./requestLogger";

interface LogItemProps {
    event: RemoteApiEventDetail;
}

const titles: Record<RemoteApiEventDetail["type"], string> = {
    request: "Request",
    response: "Response",
    cancelRequest: "Cancel request",
    handlerNotFound: "Request handler not found",
};

const Li = styled.li`
    word-break: break-all;
`;

function formatTime(time: Date) {
    const hours = String(time.getHours()).padStart(2, "0");
    const minutes = String(time.getMinutes()).padStart(2, "0");
    const seconds = String(time.getSeconds()).padStart(2, "0");
    const milliseconds = String(time.getMilliseconds()).padStart(3, "0");
    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
}

function* getEventField(event: RemoteApiEventDetail) {
    yield <Li key={"apiSpecId"}>API Spec ID: {event.apiSpecId}</Li>;
    yield <Li key={"endpointId"}>Endpoint ID: {event.endpointId}</Li>;
    if (event.type === "request") {
        yield <Li key={"parameters"}>Parameters: {event.parameters}</Li>;
    } else if (event.type === "response") {
        yield <Li key={"status"}>Status: {event.status}</Li>;
        yield <Li key={"metadata"}>Metadata: {event.metadata}</Li>;
    }
    if (event.type === "request" || event.type === "response") {
        yield <Li key={"body"}>Body: {event.body.length ? event.body : "(Empty)"}</Li>;
    }
}

export function LogItem({ event }: LogItemProps) {
    return (
        <div>
            <span>
                {formatTime(event.time)} - {titles[event.type]}:
            </span>
            <ul>{Array.from(getEventField(event))}</ul>
        </div>
    );
}
